import dataService from "../../api";
import { startLoading, stopLoading, serverErrorMessage, showNotification, showAlert, catchHandler } from "../../utils/helpers";
import { status } from "../../utils/common";

const state = {
    assignments: [],
    assignment: {
        employees: []
    },
    totalItems:0,

};

const getters = {
    index: state => assignmentId => state.assignments.findIndex(i => i.assignmentId === assignmentId)
};

const mutations = {
    setassignments: (state, r) => (state.assignments = r),
    setTotalItems: (state, r) => (state.totalItems = r),

    add: (state, r) => state.assignments.unshift(r),
    delete: (state, index) => state.assignments.splice(index, 1),
    lock: (state, index) => state.assignments[index].status = status.locked,
    unlock: (state, index) => state.assignments[index].status = status.active,
    setassignment: (state, r) => (state.assignment = r),
    edit: (state, { index, r }) => state.assignments.splice(index, 1, r),

};

const actions = {
    async getAll({ commit },params) {
        try {
            const paramsString = Object.entries(params)
            .filter(([, val]) => val !== null)
            .map(([key, val]) => `${key}=${val}`)
            .join("&");
            startLoading()
            const response = await dataService.assignments.getAll(paramsString);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setassignments", response.data.assignments);
            commit("setTotalItems", response.data.totalItems);

          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async add({ commit }, payload) {
        try {
            console.log(payload);
            let formdata = new FormData()
            //let myDate = new Date(payload.assignmentDate);
            formdata.append("assignmentTypeId", payload.assignmentTypeId);
            formdata.append("assignmentNo", payload.assignmentNo);
            formdata.append("assignmentDate", payload.assignmentDate);
            //formdata.append('assignmentDate', myDate.toISOString());
            formdata.append("description", payload.description);
            formdata.append("attachment", payload.attachment);
            formdata.append("attachmentName", payload.attachmentName);
            //formdata.append("employees", JSON.stringify(payload.employees));
            payload.employees.forEach(number => {
                formdata.append('employees[]', number);
              });
              console.log(formdata);

            startLoading()
            const response = await dataService.assignments.add(formdata);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);
            commit("add", response.data.assignment);


        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
    async delete({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.assignments.delete(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("delete", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async lock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.assignments.lock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);


            const index = getters.index(id);
            commit("lock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async unlock({ commit, getters }, id) {
        try {
            startLoading()
            const response = await dataService.assignments.unlock(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            showNotification(response.data.message);

            const index = getters.index(id);
            commit("unlock", index);
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getDetails({ commit }, id) {
        try {
            commit("setassignment", {});
            console.log(id)
            startLoading()
            const response = await dataService.assignments.getDetails(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            commit("setassignment", response.data.assignment);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async getForEdit(_, id) {
        try {
            startLoading()
            const response = await dataService.assignments.getForEdit(id);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }

            return Promise.resolve(response.data.assignment);
          
        } catch (error) {
            stopLoading()
            catchHandler(error);
        }
    },
    async edit({ commit, getters }, { id, payload }) {
        try {
            console.log(payload);
            let formdata = new FormData()
            //let myDate = new Date(payload.assignmentDate);
            formdata.append("assignmentTypeId", payload.assignmentTypeId);
            formdata.append("assignmentNo", payload.assignmentNo);
            formdata.append("assignmentDate", payload.assignmentDate);
            //formdata.append('assignmentDate', myDate.toISOString());
            formdata.append("description", payload.description);
            formdata.append("attachment", payload.attachment);
            formdata.append("attachmentName", payload.attachmentName);
            formdata.append("attachment", payload.attachment);
            //formdata.append("employees", JSON.stringify(payload.employees));
            payload.employees.forEach(number => {
                formdata.append('employees[]', number);
              });
            startLoading()
            const response = await dataService.assignments.edit(id, formdata);
            stopLoading()

            if (!response.data.statusCode) {
               showAlert(serverErrorMessage);
               return;
            }


            const index = getters.index(id);
            console.log(index);
            console.log(response.data.assignment );
            commit("edit", { index, r: response.data.assignment });

            return Promise.resolve()
        } catch (error) {
            stopLoading()
            catchHandler(error);
            return Promise.reject(error);
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
};
